import { render, staticRenderFns } from "./Envases.vue?vue&type=template&id=0f341a34&scoped=true"
import script from "./Envases.vue?vue&type=script&lang=js"
export * from "./Envases.vue?vue&type=script&lang=js"
import style0 from "./Envases.vue?vue&type=style&index=0&id=0f341a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f341a34",
  null
  
)

export default component.exports